import config from 'config';

const LOAD = 'greyhound-racing/fast-results/LOAD';
const LOAD_SUCCESS = 'greyhound-racing/fast-results/LOAD_SUCCESS';
const LOAD_FAIL = 'greyhound-racing/fast-results/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        fastResults: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.greyhoundRacing
      && globalState.greyhoundRacing.fastResults
      && globalState.greyhoundRacing.fastResults.loading;
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.greyhoundRacing.loadFastResult}`)
  };
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/reducers/fastResults.js